import { render, staticRenderFns } from "./PartnerTables.vue?vue&type=template&id=15a03ada&"
import script from "./PartnerTables.vue?vue&type=script&lang=js&"
export * from "./PartnerTables.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports